import { Autorenew } from '@mui/icons-material';
import { styled } from '@mui/material';



export const FC = styled(Autorenew)({
  animation: 'spin 2s linear infinite',
  '@keyframes spin': {
    '0%': {
      transform: 'rotate(0deg)'
    },
    '100%': {
      transform: 'rotate(360deg)'
    }
  }
});
